import * as React from 'react';
import Box from '@mui/material/Box';
import { DataGrid } from '@mui/x-data-grid';

const columns = [
  { field: 'id', headerName: 'S.NO', width: 90 },
  {
    field: 'requestId',
    headerName: 'Request Id',
    width: 150,
    editable: false,
  },
  {
    field: 'req.no',
    headerName: 'Req. No',
    width: 150,
    editable: false,
  },
  {
    field: 'settlementid',
    headerName: 'Settlement ID',
    width: 200,
    editable: false,
  },
  {
    field: 'koid',
    headerName: 'KO ID',
    width: 200,
    editable: false,
  },
  {
    field: 'amount',
    headerName: 'Amount',
    width: 200,
    editable: false,
  },
  {
    field: 'agentcode',
    headerName: 'Agent Code',
    width: 200,
    editable: false,
  },
  {
    field: 'redateandtime',
    headerName: 'Re Date and Time',
    width: 200,
    editable: false,
  },
  {
    field: 'mobile',
    headerName: 'Mobile No',
    width: 200,
    editable: false,
  },
  {
    field: 'benename',
    headerName: 'Bene Name',
    width: 200,
    editable: false,
  },
  {
    field: 'acno',
    headerName: 'A/C No',
    width: 200,
    editable: false,
  },
  {
    field: 'ifsccode',
    headerName: 'IFSC Code',
    width: 200,
    editable: false,
  },
  {
    field: 'benebank',
    headerName: 'Bebe Bank Name',
    width: 200,
    editable: false,
  },
  {
    field: 'dateoftransaction',
    headerName: 'Date of Transaction',
    width: 200,
    editable: false,
  },
  {
    field: 'openinglimit',
    headerName: 'Opening Limit',
    width: 200,
    editable: false,
  },
  {
    field: 'closinglimit',
    headerName: 'Closing Limit',
    width: 200,
    editable: false,
  },
  {
    field: 'transacrefdate',
    headerName: 'Transaction Ref Date',
    width: 200,
    editable: false,
  },
  {
    field: 'bankrefno',
    headerName: 'Bank Ref No',
    width: 200,
    editable: false,
  },
  {
    field: 'bankac',
    headerName: 'Bank A/C TypBank A/C',
    width: 200,
    editable: false,
  },
  {
    field: 'status',
    headerName: 'Status',
    width: 200,
    editable: false,
  },
  {
    field: 'remarks',
    headerName: 'Remarks',
    width: 200,
    editable: false,
  },
  
];

const rows = [
  { id: 1, lastName: 'Snow', firstName: 'Jon', age: 14 },
  { id: 2, lastName: 'Lannister', firstName: 'Cersei', age: 31 },
  { id: 3, lastName: 'Lannister', firstName: 'Jaime', age: 31 },
  { id: 4, lastName: 'Stark', firstName: 'Arya', age: 11 },
  { id: 5, lastName: 'Targaryen', firstName: 'Daenerys', age: null },
  { id: 6, lastName: 'Melisandre', firstName: null, age: 150 },
  { id: 7, lastName: 'Clifford', firstName: 'Ferrara', age: 44 },
  { id: 8, lastName: 'Frances', firstName: 'Rossini', age: 36 },
  { id: 9, lastName: 'Roxie', firstName: 'Harvey', age: 65 },
];

export default function StatusGrid() {
  return (
    <Box sx={{ height: 400, width: '100%' }}>
      <DataGrid
        rows={rows}
        columns={columns}
        initialState={{
          pagination: {
            paginationModel: {
              pageSize: 5,
            },
          },
        }}
        pageSizeOptions={[5]}
        
        disableRowSelectionOnClick
        editMode={false}
      />
    </Box>
  );
}
